module.exports = __webpack_public_path__ + "static/img/shaokao.1bbc4022.png";